export const links = [
    {
        id:1,
        url:'/MedCare',
        text:'Home'
    },
    {
        id:2,
        url:'/MedCare/about',
        text:'About'
    },
    {
        id:3,
        url:'/MedCare/services',
        text:'Services'
    },
] 

export const user_int = [
    {
        id:1,
        url:'/MedCare/Log-in',
        text:'Login'

    },
]
